import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import translateEN from './en/translation.json';
import translateUK from './uk/translation.json';
import { APP_CONFIG } from '../app.config';

const resources = {
  en: {
    translation: translateEN,
  },
  uk: {
    translation: translateUK,
  },
};

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .use(I18nextBrowserLanguageDetector)
  .init({
    resources,
    fallbackLng: APP_CONFIG.FALLBACK_LOCALE,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
